import React from "react"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "src/components/ui/sheet"
import { useToast } from "src/components/ui/toast"
import { TemplateForm } from "./TemplateForm"
import { useCreateTemplate, useUpdateTemplate } from "../hooks/useTemplates"
import { CHANNEL_MAP } from "../constants"

export function TemplateDrawer({ open, template, channel, onClose, onSuccess }) {
  const isEdit = !!template
  const { toast } = useToast()
  const createHook = useCreateTemplate()
  const updateHook = useUpdateTemplate()
  const isPending = createHook.isPending || updateHook.isPending
  const channelLabel = CHANNEL_MAP[channel]?.label || channel

  async function handleSubmit(payload) {
    try {
      if (isEdit) {
        await updateHook.mutate(template.id, payload)
        toast({ title: "Template updated", description: payload.name })
      } else {
        await createHook.mutate(payload)
        toast({ title: "Template created", description: payload.name })
      }
      onSuccess?.()
      onClose()
    } catch (errors) {
      const msg = Array.isArray(errors) ? errors[0] : errors?.message || "Something went wrong"
      toast({ variant: "destructive", title: "Error", description: msg })
    }
  }

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="flex flex-col p-0 sm:max-w-[640px]">
        <SheetHeader>
          <SheetTitle>{isEdit ? "Edit" : "New"} {channelLabel} template</SheetTitle>
          <SheetDescription>
            Compose a reusable {channelLabel} message with variables that fill in per recipient.
          </SheetDescription>
        </SheetHeader>
        <TemplateForm
          template={template}
          channel={channel}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isPending={isPending}
        />
      </SheetContent>
    </Sheet>
  )
}
